import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const recent = {};

export const track = (feature, action = "view") => {
  try {
    if (!feature) return;
    const key = `${feature}:${action}`;
    const now = Date.now();
    if (recent[key] && now - recent[key] < 30000) return;
    recent[key] = now;
    axios.post(`${API}/track`, { feature, action }).catch(() => {});
  } catch {
    /* rastreamento nunca deve quebrar a UI */
  }
};
